<template>
  <div class="catalog-deliveries">
    <div v-for="{ printName, price, time } in deliveries" class="delivery">
      <div>
        <p class="delivery__title">
          {{ printName }}
        </p>
        <DefPriceDelivery :result="price" />
      </div>
      <div>
        {{ messages?.willDeliver }}
        {{ time?.messages?.deliveryArrivalTime }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DefPriceDelivery from '@components/Def/DefPrice/DefPriceDelivery.vue';
import { useStore } from '@/store';

const {
  state: { product: productState },
} = useStore();

const deliveries = computed(() => productState.data.product.deliveries);
const messages = computed(() => productState.data.messages);
</script>

<style lang="scss" scoped>
.catalog-deliveries {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 16px;
  padding: 16px;
  border: 1px solid var(--color-grey);
}
.delivery {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-column-gap: 16px;
  &__title {
    font-size: 14px;
    font-weight: 500;
    line-height: 125%;
    margin-bottom: 4px;
  }
}
</style>
